import { feeTypes } from '@/configuration/pages/ConfigurationPage/LogisticsConfiguration/DeliveryMethods/DeliveryMethodDetailConfiguration/constants'

export const handleChangeCurrency = (currency, onChange) => {
  onChange({ currency })
}

export const handleChangeExtraFee = (value, type, onChange) => {
  onChange({ [type]: value })
}

export const shouldShowExtraFeeAdditionalTransaction = ({
  extraFeeType,
  extraAdditionalFee,
  baseExtraAdditionalFee,
}) => {
  if (extraFeeType === feeTypes.flatFee && Number(extraAdditionalFee)) {
    return true
  }

  if (extraFeeType === feeTypes.perReturnedItem && (Number(baseExtraAdditionalFee) || Number(extraAdditionalFee))) {
    return true
  }

  return false
}
